import { Box, HStack } from "@chakra-ui/react";
import CDS from "design-system";

import AutosaveTrixField from "./AutosaveTrixField";

interface Props {
  value: string | null;
  onChange: (nextValue: string) => void;
}

export default function InstructionsCard({ value, onChange }: Props) {
  return (
    <Box borderWidth="1px" borderColor="border.subtle" borderRadius="base" p={4} bg="bg.documentFieldRest">
      <HStack spacing={2} mb={2}>
        <CDS.Text14 fontWeight="bold" color="content.primary">Instructions</CDS.Text14>
        <CDS.Text12 color="content.tertiary">(shown to respondents)</CDS.Text12>
      </HStack>

      <AutosaveTrixField
        value={value}
        onChange={onChange}
        placeholder="Add a short intro for people filling this out"
      />
    </Box>
  );
}
